import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';
import React, { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';

import ModalPortal from '@/src/components/common/Modal/ModalPortal';
import { LibraryActionEnum } from '@/src/components/project/api/getProjectPermissions';
import { useLibraryListStore } from '@/src/components/project/Library/store/library-list.store';
import { useToggle } from '@/src/hooks/useToggle';

import FolderManageAccessList from '../../../../Modal/ManageAccessList/FolderManageAccessList';
import CopyFileUrl from '../CopyFileUrl/CopyFileUrl';
import DeleteSingle from '../Delete/DeleteSingle';
import ManageAccess from '../ManageAccess/ManageAccess';
import Rename from '../Rename/Rename';

const Actions = ({ file, itemIdsVersioned }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const { projectId } = useParams<{ projectId: string }>();
  const permissions = useLibraryListStore((s) => s.permissions);
  const isEditor = useMemo(() => {
    return permissions.library?.actions?.some(
      (action) => action.name === LibraryActionEnum.MANAGE_ACCESS && action.allowed
    );
  }, [permissions]);

  const open = Boolean(anchorEl);
  const [isManageFileAccessModalOpen, toggleIsManageFileAccessModalOpen] = useToggle(false);

  const handleClickManageAccess = () => {
    dispatch({ type: 'UPDATE_FILES_ACTION_ITEM', action: 'accessInCreateFolder' });
    toggleIsManageFileAccessModalOpen(false);
  };

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="fileActionsContainer tw-flex tw-items-center">
      <a onClick={handleClick} className={`vertIcon ${open ? 'active' : ''}`}>
        <i className="material-icons">more_vert</i>
      </a>
      <Popper open={open} anchorEl={anchorEl} placement="left-start" style={{ zIndex: 100 }}>
        <ClickAwayListener onClickAway={handleClose}>
          <div className="fileActionsItem">
            {file.type !== 'folder' && (
              <React.Fragment>
                <div className="actionItem">
                  <CopyFileUrl
                    projectId={projectId}
                    fileId={file.id}
                    sourceId={file['source-id']}
                  />
                </div>

                {/* {enableActiveAction && (
                  <div className="actionItem">
                    <Duplicate file={file} projectId={projectId} />
                  </div>
                )} */}
                {/* {enableActiveAction && (
                  <div className="actionItem">
                    <Read file={file} projectId={projectId} />
                  </div>
                )} */}
                <div className="actionItem">
                  <DeleteSingle
                    file={file}
                    itemIdsVersioned={itemIdsVersioned}
                    inTrash={false}
                    showLabel={true}
                  />
                </div>
              </React.Fragment>
            )}
            {file.type === 'folder' && (
              <React.Fragment>
                {/* <div className="actionItem">
                  <Duplicate file={file} projectId={projectId} />
                </div> */}

                {isEditor && (
                  <div className="actionItem">
                    <ManageAccess file={file} onSelect={toggleIsManageFileAccessModalOpen} />
                  </div>
                )}
                <div className="actionItem">
                  <Rename file={file} onClick={handleClose} />
                </div>
                <div className="actionItem">
                  <DeleteSingle
                    file={file}
                    itemIdsVersioned={itemIdsVersioned}
                    inTrash={false}
                    showLabel={true}
                  />
                </div>
              </React.Fragment>
            )}
          </div>
        </ClickAwayListener>
      </Popper>
      {isEditor && file.type === 'folder' && isManageFileAccessModalOpen && (
        <ModalPortal>
          <FolderManageAccessList onClose={handleClickManageAccess} folderId={file.id} />
        </ModalPortal>
      )}
    </div>
  );
};

export default Actions;
